<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.16667 8.33325C7.75 8.58325 6.5 9.08325 5.33333 9.99992L3 7.58325V13.4166H8.83333L6.58333 11.1666C9.66667 8.99992 13.9167 9.66659 16.1667 12.7499C16.3333 12.9999 16.5 13.1666 16.5833 13.4166L18.0833 12.6666C16.25 9.49992 12.75 7.74992 9.16667 8.33325Z"/>
</svg>
